import { Rfp } from '@interfaces/buyer-view/rfp-list/Rfp';
import Formatters from '../../globals/Formatters';
import serverFetch from '../../globals/ServerFetch';

export interface RfpItemAttachment {
	/** Nazwa załącznika */
	Name: string;
	/** Ścieżka do miniaturki */
	Thumbnail: string;
	/** Ścieżka do pliku źródłowego */
	Path: string;
}
export interface RfpItemDescriptionField {
	Label: string;
	Value: string;
}

export interface RfpItemContactPerson {
	Phone: string;
	Email: string;
	CompanyName: string;
	ShortName: string;
	FirstName: string;
	LastName: string;
}

export interface RfpItemNote {
	Id: number;
	Contents: string;
	Date: Date;
}

export interface RfpLocation {
	City: [string, string];
	Region: [string, string];
	Country: [string, string];
	District: [string, string];
	Coords: [number, number];
}

export interface RfpLastMessage {
	Message: string;
	IsMine: boolean;
	IsRead: boolean;
	UnreadMessagesCount: number;
	LastChatAction: number;
}

export interface RfpOffer {
	Name: string;
	CustomerId: number;
	Date: Date;
	RatingAverage: number;
	ReviewsCount: number;
}

export type RfpCategory = [number, string];
export type RfpFolder = 'RECEIVED' | 'ARCHIVED';
export type RfpCooperationStatus = string;
export interface RfpItem {
	Id: number;
	Title: string;
	Url: string;
	IsUncovered: boolean;
	UncoverInProgress: boolean;
	IsUnread: boolean;
	IsSeen: boolean;
	IsLoaded: boolean;
	HasPhone: boolean;
	InvalidRedirect: boolean;
	InactiveReason: string;
	DisableReason: string;
	UncoverInactiveReason: string;
	ContactPrice: number;
	OriginalContactPrice: number;
	BlockedUncoverLimit: number;
	UncoverLimit: number;
	Autorefund: boolean;
	EditRfpLink: string;
	OffersCountLabel: string;
	RefundReason: string;
	CreationDate: Date;
	Attachments: RfpItemAttachment[];
	Description: RfpItemDescriptionField[];
	OffersCount: number;
	OffersCountForUser: number;
	RealizationDate: Date;
	EmailConfirmed: boolean;
	IsEmailFaulty: boolean;
	HalfPriceBadge: boolean;
	PhoneConfirmed: boolean;
	PriceBelowMinimumVague: boolean;
	BuyerUndecidedNotChecked: boolean;
	BuyerUndecided: boolean;
	BuyerWithoutPhone: boolean;
	BuyerWithSmallBudgetAfterCall: boolean;
	BuyerWithSmallBudget: boolean;
	IsExpired: boolean;
	FirstUncoverFree: boolean;
	IsSold: boolean;
	ClientRequestData: boolean;
	RedirectToList: boolean;
	IsDiscounted: boolean;
	HasAttachments: boolean;
	CooperationStatus: RfpCooperationStatus;
	Category: RfpCategory;
	CategoryParent: RfpCategory;
	CategoryLevel2: RfpCategory;
	CategoryLevel3: RfpCategory;
	Tags: string[];
	AdditionalTags: string[];
	PdfUrl: string;
	Folder: RfpFolder;
	Notes: RfpItemNote[];
	ContactPerson: RfpItemContactPerson;
	IsFavourite: boolean;
	UncoverType: string;
	Location: RfpLocation;
	LastMessage: RfpLastMessage;
	NipVerificationStatus: 'NeedsVerification' | 'VerficationSent' | 'VerificationInProgress' | '';
	SimilarRfps: RfpItem[];
	Offers: RfpOffer[];
	AutorefundRfps: { title:string, id:number }[];
	PhoneConfirmationStatus: string;
	isHideBuyerMail: boolean;
	IsCustomerWaitingForOffers: boolean;
	IsLastChance: boolean;
	creationDateLabel: string;
	timePromoCountdown: number;
}

export interface RfpItemLabel {
	text: string;
	class: string;
	tooltip?: string;
}

export default class RfpsList {
	TotalResults = -1;

	Page = -1;

	Filters = [];

	FiltersCount = 0;

	CurrentFilter = {};

	Results = [{
		Type: 'FILTER_SINGLE',
		Value: 'ORDER_DATE',
		Options: ['ORDER_DATE', 'ORDER_NEAREST'],
	}];

	Type = '';

	LastUpdated = -1;

	Loaded = false;

	LoadingMore = false;

	Rfps = [];

	AdditionalRfps = [];

	AdditionalRfpsSectionLabel = '';

	AdditionalRfpsSectionTooltip = '';

	Format = new Formatters();

	SearchModified = false;

	OnlineStatusList = {};

	DisplayIntroMessage = false;

	IsLoading = false;

	PfInfoModal = false;

	PfLabelTutorial = false;

	newApCategories = false;

	newApCategoriesOB = false;

	AdditionalSections = {};

	ExpiredItemsCount = 0;

	SearchTimeout?:number;

	SearchLoader = false;

	ArchivedRfpsCount = 0;

	ShowBestRfps = false;

	DefaultSort = '';

	timePromoRfp?:RfpItem;

	constructor(t) {
		this.Type = t;
	}

	PrepareFilters(filters = {}, availableFilters) { // eslint-disable-line no-unused-vars
		let result = [];

		const category = {
			Name: 'idCategories',
			Type: 'multi',
			Label: 'Kategoria',
			Items: [],
			Value: [],
			Icon: 'list-desc',
			IsExpanded: false,
		};

		const sort = {
			Name: 'sort',
			Type: 'select',
			Label: 'Sortuj',
			Items: [{
				Value: 'SORT_DATE',
				Label: 'Od najnowszych',
				Icon: 'sort',
			},
			{
				Value: 'SORT_DISTANCE',
				Label: 'Od najbliższych',
				Icon: 'sort',
			}],
			Icon: 'sort',
			Value: 'SORT_DATE',
			Default: 'SORT_DATE',
			IsExpanded: false,
		};

		if (this.ShowBestRfps) {
			sort.Items.unshift({
				Value: 'SORT_BEST',
				Label: 'Od najlepszych',
				Icon: 'sort',
			});
			sort.Value = 'SORT_BEST';
			sort.Default = 'SORT_BEST';
		}

		if (this.DefaultSort) {
			sort.Value = this.DefaultSort;
			sort.Default = this.DefaultSort;
		}

		const search = {
			Name: 'search',
			Type: 'string',
			Label: this.Type !== 'Rfps' ? 'Szukaj po nazwie zlecenia' : 'Szukaj po nazwie kontaktu',
			Hidden: true,
			Value: '',
			DisplayMobileInput: false,
		};

		if (this.Type === 'Rfps') {
			const distance = {
				Name: 'distance',
				Type: 'select',
				Label: 'Lokalizacja',
				Items: [],
				Value: '',
				IsExpanded: false,
			};

			if (availableFilters) {
				distance.Items = [];
				const d = availableFilters.distance;
				if (d > 5) {
					distance.Items.push({
						Value: 5,
						Label: 'do 5 kilometrów',
					});
				}
				if (d > 10) {
					distance.Items.push({
						Value: 10,
						Label: 'do 10 kilometrów',
					});
				}
				if (d > 30) {
					distance.Items.push({
						Value: 30,
						Label: 'do 30 kilometrów',
					});
				}
				if (d > 50) {
					distance.Items.push({
						Value: 50,
						Label: 'do 50 kilometrów',
					});
				}
				if (d > 100) {
					distance.Items.push({
						Value: 100,
						Label: 'do 100 kilometrów',
					});
				}
				if (d > 250) {
					distance.Items.push({
						Value: 250,
						Label: 'do 250 kilometrów',
					});
				}
				distance.Items.push({
					Value: '',
					Label: 'wszystkie wybrane powiaty',
				});
			}

			const otherFilters = [{
				Name: 'withPhone',
				Type: 'bool',
				Label: 'Z numerem potwierdzonym SMS',
				Value: false,
			},
			{
				Name: 'withAttachments',
				Type: 'bool',
				Label: 'Z załącznikami',
				Value: false,
			},
			{
				Name: 'notSeen',
				Type: 'bool',
				Label: 'Nieprzeczytane',
				Value: false,
			},
			{
				Name: 'noOffers',
				Type: 'bool',
				Label: 'Bez ofert',
				Value: false,
			},
			{
				Name: 'onlyDiscounts',
				Type: 'bool',
				Label: 'Przecenione',
				Value: false,
			},
			{
				Name: 'onlyFavourites',
				Type: 'bool',
				Label: 'Obserwowane',
				Value: false,
			},
			];

			const rfpType = {
				Name: 'rfpType',
				Type: 'select',
				Label: 'Typ podmiotu',
				Items: [
					{ Value: '', Label: 'Wszyscy' },
					{ Value: 'individual', Label: 'Osoby prywatne' },
					{ Value: 'company', Label: 'Firmy' },
				],
				Value: '',
				IsExpanded: false,
			};

			if (this.ShowBestRfps) {
				otherFilters.push({
					Name: 'onlyBest',
					Type: 'bool',
					Label: 'Tylko najlepsze',
					Value: false,
				});
			}

			result = [category, distance, rfpType, ...otherFilters, sort, search]; // , startDate
		}

		if (this.Type !== 'Rfps') {
			const folder = {
				Name: 'folder',
				Type: 'select',
				Label: 'Pokaż',
				Items: [{
					Value: 'INCOMING',
					Label: 'Przychodzące',
					Icon: 'chat',
				},
				{
					Value: 'FAVOURITE',
					Label: 'Obserwowane',
					Icon: 'star-off',
				},
				{
					Value: 'WON',
					Label: 'Potwierdzone',
					Icon: 'handshake',
				},
				{
					Value: 'ARCHIVED',
					Label: 'Archiwum',
					Icon: 'archive-small',
				},
				],
				Value: 'INCOMING',
				Default: 'INCOMING',
			};

			const otherFilters = [
				{
					Name: 'onlyIm',
					Type: 'bool',
					Label: 'Polecanie',
					Icon: 'megaphone',
					Value: false,
				},
				{
					Name: 'onlyNew',
					Type: 'bool',
					Label: 'Nowy kontakt',
					Icon: 'dot',
					Value: false,
				},
				{
					Name: 'onlySent',
					Type: 'bool',
					Label: 'Wysłana wiadomość',
					Icon: 'reply',
					Value: false,
				},
				{
					Name: 'onlyUnread',
					Type: 'bool',
					Label: 'Nieprzeczytana wiadomość',
					Icon: 'mail-opened',
					Value: false,
				},
			];

			result = [search, folder, category, ...otherFilters, sort];
		}

		return result;
	}

	SetFilterQuery(filterQuery) {
		const filters = this.Filters;
		if (filterQuery) {
			for (const q of filterQuery.split(',')) {
				const qq = q.split(':');
				const filter = filters.find((f) => f.Label.toLowerCase().replace(/ /g, '-') === qq[0]);
				let val;
				if (!filter) { continue; }
				switch (filter.Type) {
				case 'bool': filter.Value = true; break;
				case 'select':
					filter.Value = (Number(qq[1]) == qq[1]) ? Number(qq[1]) : qq[1]; // eslint-disable-line eqeqeq
					break;
				case 'multi':
					val = [];
					if (qq[1]) {
						qq[1].split(';').forEach((e) => {
							val.push((Number(e) == e) ? Number(e) : e); // eslint-disable-line eqeqeq
						});
					}
					filter.Value = qq[1] ? qq[1].split(';') : [];
					break;
				default: break;
				}
			}
		}
	}

	UpdateCategoryFilters(availableFilters) {
		const categoryFilter = this.Filters.find((f) => f.Name === 'idCategories');
		if (!(categoryFilter && availableFilters && availableFilters.categories)) { return; }

		const originalCategoryFilterValue = categoryFilter.Value;
		categoryFilter.Items = [];
		categoryFilter.Value = [];
		for (const category of availableFilters.categories) {
			categoryFilter.Items.push({ Value: category.id, Label: category.name });
			if (originalCategoryFilterValue.indexOf(category.id) > -1) {
				categoryFilter.Value.push(category.id);
			}
		}
	}

	FiltersToQuery() {
		const result = [];
		for (const f of this.Filters) {
			if (f.Value === '' || (Array.isArray(f.Value) && !f.Value.length) || f.Value === false || f.IsTagFilter) { continue; }
			const name = f.Label.replace(/ /g, '-').toLowerCase();
			if (name === 'sortuj') { continue; }
			switch (f.Type) {
			case 'bool': result.push(name); break;
			case 'select': result.push(`${name}:${f.Value}`); break;
			case 'multi': result.push(`${name}:${f.Value.join()}`); break;
			default: break;
			}
		}
		return result.join(',');
	}

	TagFilterToggle(tag:string) {
		const filterIndex = this.FindTagFilterIndex(tag);
		if (filterIndex === -1) {
			// Dodaj filtr z tagiem.
			this.Filters.push({
				Label: tag,
				Name: 'tag',
				Type: 'bool',
				Value: true,
				IsTagFilter: true,
			});
		} else {
			// Usuń filtr z tagiem.
			this.Filters.splice(filterIndex, 1);
		}

		this.Get();
	}

	FindTagFilterIndex(tag:string) {
		const result = this.Filters.findIndex((filter) => filter.Label === tag);
		return result;
	}

	PrepareFiltersUrl(filters) {
		let result = '';
		const dataObject = {} as any;
		const tags = [];
		filters = filters.filter((f) => {
			const v = f.Value;
			return (v === true || v.length || (typeof v === 'number' && String(v).length)) && v !== f.Default || f.Name === 'sort';
		});

		for (const f of filters) {
			if (f.IsTagFilter) {
				tags.push(f.Label);
				continue;
			}

			dataObject[`data.${f.Name}`] = f.Value;

			if (Array.isArray(f.Value)) {
				f.Value.forEach((v) => {
					result += `&data.${f.Name}=${v}`;
				});
			} else {
				result += `&data.${f.Name}=${f.Value}`;
			}

			if (f.Name === 'onlyFavourites') {
				dataObject['data.folder'] = 'FAVOURITE';
				result += '&data.folder=FAVOURITE';
			}
		}

		dataObject['data.tags'] = tags;

		// Nie liczymy sortowania jako filtr
		let count = filters.length;
		if (dataObject['data.sort']) {
			count -= 1;
		}

		return {
			Url: result,
			DataObject: dataObject,
			Count: count,
		};
	}

	GetListUrl(limit = 25) {
		return `/myoferteo/konto-json/${this.Type === 'Rfps' ? 'zapytania' : 'kontakty'}.ofer?data.limit=${limit}`;
	}

	GetContactPerson(cp, rfp) {
		cp = {
			ShortName: cp.shortName,
			FirstName: cp.firstName,
			LastName: cp.lastName,
			CompanyName: cp.companyName,
			Email: cp.email,
			Phone: cp.phone,
			Sex: cp.sex,
			OnlineStatus: cp.onlineStatus,
			Nip: cp.nip,
			OnlineStatusId: null,
			CustomerId: (rfp && rfp.idCustomer) ? rfp.idCustomer : 0,
			RfpId: rfp.id,
		};
		cp.OnlineStatusId = cp.RfpId;
		return cp;
	}

	ReplaceHTML(input: string): string {
		const tagsToRemove = new Set([
			'a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo',
			'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup',
			'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed',
			'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
			'head', 'header', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'label', 'legend',
			'li', 'link', 'main', 'map', 'mark', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol',
			'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rb', 'rp',
			'rt', 'rtc', 'ruby', 's', 'samp', 'script', 'section', 'select', 'slot', 'small', 'source',
			'span', 'strong', 'style', 'sub', 'summary', 'sup', 'svg', 'table', 'tbody', 'td', 'template',
			'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video',
			'wbr',
		]);

		const pattern = new RegExp(`<\\/?(?:${Array.from(tagsToRemove).join('|')})[\\s\\S]*?>`, 'gi');
		const output = input.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');
		const finalOutput = output.replace(pattern, '');

		return finalOutput;
	}

	GetRfpDescription(rfp) {
		const r = [];
		r.push({
			Label: 'Kategoria',
			Value: rfp.Category[1],
			HideInPublic: true,
		});

		const l = rfp.Location;
		let location = `${l.City[1]}, `;
		location += (l.Country[0] === 'locationPl') ? `${l.District[1]}, ${l.Region[1]}` : l.Country[1];
		r.push({
			Label: 'Miejsce',
			Value: location,
		});

		if (rfp.IsUncovered && rfp.ContactPerson.Nip) {
			r.push({
				Label: 'NIP',
				Value: rfp.ContactPerson.Nip,
			});
		}

		if (rfp.IsUncovered && rfp.ContactPerson.CompanyName) {
			r.push({
				Label: 'Nazwa firmy',
				Value: rfp.ContactPerson.CompanyName,
			});
		}

		if (rfp.TransportInfo) {
			const transport = (label, v) => {
				if (!rfp.TransportInfo[v]) {
					return;
				}
				r.push({
					Label: label,
					Value: rfp.TransportInfo[v],
				});
			};
			transport('Załadunek', 'AddressFrom');
			transport('Rozładunek', 'AddressTo');
			transport('Termin załadunku od', 'FromDate');
			transport('Termin rozładunku do', 'ToDate');
			transport('Nadwozie', 'CargoBody');
			transport('Ciężar ładunku', 'CargoWeight');
			transport('Rodzaj ładunku', 'CargoType');
		}

		let description = this.ReplaceHTML(rfp.Description);
		description = description.split('\n');

		const d = [];
		for (let line of description) {
			try {
				line = line.trim();
				if (!line) {
					continue;
				}
				line = line.split(/(.+:) (.+)/gm);
				if (line.length === 1) {
					line = line[0];
					if (line.endsWith(':')) {
						d.push({
							Label: line.replace(':', ''),
							Value: '',
						});
					} else {
						const val = line.startsWith('- ') ? `<div class="description-point">${line.replace('- ', '')}</div>` : `${line}<br>`;
						d[d.length - 1].Value += val;
					}
				} else {
					d.push({
						Label: line[1],
						Value: line[2],
					});
				}
			} catch (err) {
				DBG('GetRfpDescription', line, err);
			}
		}

		const other = [{
			Label: 'Forma kontaktu',
			Value: rfp.ContactForms.join(', ').replace('Telefon, Telefon', 'Telefon'),
		},
		{
			Label: 'Identyfikator zapytania',
			Value: rfp.Id,
		},
		];

		if (rfp.DiscountReason) {
			other.push({ Label: 'Powód przeceny', Value: rfp.DiscountReason });
		}

		return [...r, ...d, ...other];
	}

	async SimulateFilterChange(filter) {
		const filtersCopy = JSON.parse(JSON.stringify(this.Filters));
		if (filter) {
			const replaceIdx = filtersCopy.findIndex((item) => item.Name === filter.Name);
			if (replaceIdx > -1) {
				filtersCopy[replaceIdx] = filter;
			}
		}
		const url = this.GetListUrl(1) + this.PrepareFiltersUrl(filtersCopy).Url;
		const replacedUrl = url.replace('zapytania.ofer?', 'rfps-counts.ofer?searchUncoverData=false&');
		// TODO: Liczba nie uzględnia filtrów tagów.
		return (await serverFetch(replacedUrl)).total;
	}

	ProcessRfp(r) {
		if (!r) {
			r = {};
		}

		let uncoverType = 'NONE'; // MANUAL, QC, IM, REFUND
		if (r.uncoverType === 'uncCustManual') {
			uncoverType = 'MANUAL';
		}
		if (r.uncoverType === 'uncCustSK') {
			uncoverType = 'QC';
		}
		if (r.uncoverType === 'uncBuyerAP') {
			uncoverType = 'IM';
		}
		if (r.uncoverType === 'uncBuyerPF') {
			uncoverType = 'PF';
		}
		if (r.uncoverType === 'uncFreeBuyerChoice') {
			uncoverType = 'BC';
		}

		const rfp = {
			Id: r.id || 0,
			Title: r.title || ' ',
			Url: r.titleForUrl || '0',
			IsUnread: r.unread,
			IsExpired: r.expired || r.disableReason === 'INACTIVE_RFP', // bez sensu, to backend powinien.
			IsSeen: r.isSeen,
			IsFavourite: r.favourite,
			IsUncovered: r.uncovered && !r.refundReason, // Traktujemy zwroty jak nieodkryte.
			UncoverInProgress: false,
			PriceBelowMinimumVague: r.priceBelowMinimumVague,
			ConfirmedByBuyer: r.confirmedByBuyer,
			BuyerUndecidedNotChecked: r.buyerUndecidedNotChecked,
			BuyerUndecided: r.buyerUndecided,
			BuyerWithSmallBudget: r.buyerWithSmallBudget,
			BuyerWithSmallBudgetAfterCall: r.buyerWithSmallBudgetAfterCall,
			BuyerWithoutPhone: r.buyerWithoutPhone,
			UncoverType: uncoverType,
			DisableReason: r.disableReason === 'INACTIVE_RFP' ? '' : r.disableReason,
			RefundReason: r.refundReason,
			ContactPrice: r.contactPrice,
			OriginalContactPrice: r.originalContactPrice,
			IsDiscounted: r.discounted,
			Tags: r.tags || [],
			AdditionalTags: r.additionalTags || [],
			RealizationDate: r.realizationDate,
			Description: r.description,

			// CreationDate: data aktywacja zapytania lub jego utworzenia, jeżeli nie zostało jeszcze zaktywowane
			CreationDate: r.startDate ? this.Format.Date(r.startDate) : this.Format.Date(r.creationDate),

			// StartDate: data aktywacji zapytania
			StartDate: this.Format.Date(r.startDate),

			// UncoverDate: data odkrycia zapytania przez użytkownika
			UncoverDate: this.Format.Date(r.tsUncovered),
			Size: null,
			Category: r.category ? [r.category.id, r.category.name] : ['', ''],
			CategoryParent: r.categoryParent ? [r.categoryParent.id, r.categoryParent.name] : ['', ''],
			CategoryLevel2: [(r.category || {}).idCategoryLevel2 || r.idCategoryLevel2 || '', ''],
			CategoryLevel3: r.categoryLevel3 ? [r.categoryLevel3.id, r.categoryLevel3.name] : ['', ''],
			FirstUncoverFree: r.category ? r.category.tsFirstUncoverFree > 0 : false,
			HasChat: r.hasChat,
			ChatId: r.idChat,
			ChatUrl: r.chatUrl,
			LastMessage: r.lastMessage ? {
				Message: r.lastMessage.content ? r.lastMessage.content : '',
				IsMine: r.lastMessage.mine,
				IsRead: r.lastMessage.tsRead > 0,
				UnreadMessagesCount: r.unreadMessagesCount || -1,
				LastChatAction: r.tsLastChatAction || 0,
			} : {},
			ContactPerson: null,
			Location: null,
			ContactForms: ['Email', 'Czat'],
			Folder: r.idFolder,
			OffersCount: r.offersCount,
			OffersCountForUser: r.offersCountForUser,
			Offers: [],
			ModerationStatus: {},
			HasPhone: r.contactPerson ? (r.contactPerson.phone || '').length > 0 : false,
			PhoneConfirmed: r.tsPhoneConfirmed > 0,
			EmailConfirmed: r.tsEmailConfirmed > 0,
			IsEmailFaulty: r.emailFaulty,
			TransportInfo: null,
			Notes: [],
			Autorefund: false,
			AutorefundRfps: [],
			PhoneConfirmationStatus: '',
			ClientRequestData: r.clientRequestData,
			Tutorials: r.tutorials,
			UncoverLimit: r.uncoversLimit,
			OffersCountLabel: null,
			IsSold: (typeof r.isSold !== 'undefined') ? r.isSold : (r.uncoversCount >= r.uncoversLimit),
			UncoverInactiveReason: r.uncoverInactiveReason || '',
			RegisterUrl: '/rejestracja/wybierz-klientow/',
			LoadFromData: {
				startDateFrom: r.startDate,
				expiredFrom: r.expired,
				chatDateFrom: (r.lastMessage || {}).tsCreated,
				creationDateCustomerRfpFrom: r.creationDateCustomerRfp,
				recommendedDateFrom: r.recommendedDate,
				distanceFrom: r.distanceFromCustomerHead,
			},
			NipVerificationStatus: '', // NeedsVerification, VerficationSent, VerificationInProgress,
			PdfUrl: r.pdfUrl,
			HalfPriceBadge: r.halfPriceBadge,
			EditRfpLink: r.editRfpUrl,
			CooperationConfirmationStatus: r.cooperationConfirmationStatus || '', // '', 'confirmedByBuyer', 'confirmedBySeller', 'cancelledByBuyer', 'cancelledBySeller', 'closedByBuyer', 'closedBySeller'
			CooperationStatus: (r.cooperationConfirmationStatus || '').indexOf('confirmedBy') > -1 ? 'confirmed' : r.cooperationStatus || '', // '', 'Confirm'
			CooperationBadge: r.cooperationBadge || '', // '', 'Confirmed', 'BuyerConfirmed', 'ReviewRequest', 'Done', 'DEBUG', 'MarkRequest', 'MarkRequestSent'
			CooperationStartDate: new Date(r.cooperationConfirmationTsCreated),
			InvalidRedirect: r.invalidRedirect || '',
			DiscountReason: '',
			RedirectToList: false,
			HasAttachments: r.hasAttachments || false,
			Attachments: r.attachments || [],
			InactiveReason: '',
			BlockedUncoverLimit: r.blockedUncoverLimit || 0,
			SimilarRfps: r.similarRfps?.map((similarRfp) => this.ProcessRfp(similarRfp)) || [],
			isHideBuyerMail: r.hideBuyerMail,
			IsCustomerWaitingForOffers: r.isCustomerWaitingForOffers || false,
			IsLastChance: r.isLastChance || false,
			creationDateLabel: r.creationDateLabel || '',
			timePromoCountdown: r.timePromoCountdown || 0,
		};

		rfp.Attachments = rfp.Attachments.map((i) => ({ Name: i.fileName, Thumbnail: i.thumbnail, Path: i.path }));

		if (rfp.DisableReason === 'INACTIVE_POINTS') { rfp.UncoverInactiveReason = rfp.DisableReason; rfp.DisableReason = ''; }

		if (rfp.BlockedUncoverLimit) {
			rfp.UncoverInactiveReason = 'BLOCKED_POINTS';
		}

		if (r.negotiatedPriceVerificationStatus) {
			let nvs = '';
			if (r.negotiatedPriceVerificationStatus === 'notVerified') { nvs = 'NeedsVerification'; }
			if (r.negotiatedPriceVerificationStatus === 'underVerification') { nvs = 'VerificationInProgress'; }
			rfp.NipVerificationStatus = nvs;
		}

		if (r && r.category && r.location) {
			rfp.RegisterUrl += `?cats=${r.category.id}&loc=${r.location.city[1]}&rfpId=${r.id}`;
		}

		if (!r.notes) {
			r.notes = [];
		}
		for (const n of r.notes) {
			rfp.Notes.push({
				Id: n.id,
				Date: new Date(n.tsModified || n.tsCreated),
				Contents: n.note,
			});
		}

		if (!rfp.Id || !rfp.Title) {
			rfp.InvalidRedirect = '/zlecenia';
		}

		rfp.Location = r.location ? {
			Country: r.location.country,
			Region: r.location.region,
			District: r.location.district,
			City: r.location.city,
			Coords: r.location.coords,
		} : {
			Country: ['', ''],
			Region: ['', ''],
			District: ['', ''],
			City: ['', ''],
			Coords: ['', ''],
		};

		rfp.ContactPerson = r.contactPerson ? this.GetContactPerson(r.contactPerson, r) : {};

		if (!rfp.ContactPerson.Phone) {
			rfp.BuyerWithoutPhone = true;
			rfp.PhoneConfirmed = false;
		}
		if (!rfp.BuyerWithoutPhone) {
			rfp.ContactForms.unshift('Telefon');
		}

		if (r.fromAddress && r.toAddress) {
			const address = (v) => {
				const formatted = v.match(/(.+) (\d.+)/);
				return formatted ? `${formatted[2]}, ${formatted[1]}` : v;
			};
			rfp.TransportInfo = {
				AddressFrom: address(r.fromAddress),
				AddressTo: address(r.toAddress),
				FromDate: r.fromDate,
				ToDate: r.toDate,
				CargoBody: r.body,
				CargoWeight: r.weight,
				CargoType: r.cargoType,
			};
		}

		let discountReason = '';
		if (rfp.IsDiscounted) { discountReason = 'Inny powód przeceny'; }
		if (rfp.BuyerWithoutPhone && !rfp.PriceBelowMinimumVague) { discountReason = 'Zleceniodawca nie podał numeru telefonu'; }
		if (rfp.BuyerWithSmallBudgetAfterCall) { discountReason = 'Budżet niższy niż zwykle'; }
		if (rfp.BuyerWithSmallBudget || (!rfp.PriceBelowMinimumVague && (rfp.BuyerUndecided || rfp.BuyerUndecidedNotChecked))) { discountReason = 'Termin zlecenia jest odległy'; }
		if ((rfp.HalfPriceBadge && !rfp.PriceBelowMinimumVague) || rfp.IsDiscounted) { discountReason = 'Inny powód przeceny'; }
		rfp.DiscountReason = discountReason;

		rfp.Description = r.description ? this.GetRfpDescription(rfp) : [];

		rfp.Offers = [];
		if (r.offers) {
			for (const o of r.offers) {
				rfp.Offers.push({
					Name: o.name,
					Date: this.Format.Date(o.date),
					ReviewsCount: o.reviewsCount,
					RatingAverage: (o.rating).toFixed(1),
					RatingStars: Number((o.rating * 2)).toFixed(0),
					CustomerId: o.idCustomer,
				});
			}
		}
		rfp.OffersCount = rfp.Offers.length || rfp.OffersCount;

		if (rfp.OffersCount) {
			rfp.FirstUncoverFree = false;
		}

		if (rfp.OffersCount >= rfp.UncoverLimit) { rfp.IsSold = true; }
		if (rfp.UncoverLimit < 99) {
			rfp.OffersCountLabel = { Class: 'border border-solid border-warn text-warn rounded-full px-2', Label: 'Zapytanie z limitem odkryć' };
			if (rfp.OffersCount === 0) {
				rfp.OffersCountLabel = { Class: 'border border-solid border-warn text-warn rounded-full px-2', Label: 'Bądź pierwszy!' };
			}
			if (rfp.OffersCount === (rfp.UncoverLimit - 1)) {
				rfp.OffersCountLabel = { Class: 'border border-solid border-warn text-warn rounded-full px-2', Label: 'Ostatnia szansa' };
			}
			if (rfp.OffersCount >= rfp.UncoverLimit || rfp.IsUncovered) {
				rfp.OffersCountLabel = {};
			}
		}

		rfp.ModerationStatus = {
			ModeratorName: r.confirmationOperatorFirstName,
			ModeratorAvatar: r.confirmationOperatorProfileImagePath,
			IsDiscounted: r.priceBelowMinimumVague,
		};

		// Automatyczny zwrot punktów.
		if (Array.isArray(r.uncoveredDuplicate) && r.uncoveredDuplicate.length) {
			rfp.Autorefund = true;
			for (const d of r.uncoveredDuplicate) {
				rfp.AutorefundRfps.push({
					id: d.id,
					title: d.title,
				});
			}
		}

		if (r.refundReason === 'Automatyczny zwrot punktów za ponowne odkrycie danych kontaktowych') {
			rfp.Autorefund = true;
		}

		// Status potwierdzenia RFP
		rfp.PhoneConfirmationStatus = 'Empty';
		if (rfp.HasPhone) {
			rfp.PhoneConfirmationStatus = rfp.PhoneConfirmed ? 'Confirmed' : 'NotConfirmed';
		}
		rfp.PhoneConfirmationStatus = `RfpViewNewAppPhone${rfp.PhoneConfirmationStatus}`;

		if (rfp.IsUncovered) {
			// Odkryte zapytania nie powinny mieć informacji o tym, czy wygasło lub jest sprzedane.
			rfp.IsExpired = false;
			rfp.IsSold = false;
			rfp.InvalidRedirect = '';
		} else {
			// TODO: Wypisz tutaj wartość tekstową.
			rfp.InactiveReason = rfp.IsSold || rfp.IsExpired || rfp.InvalidRedirect || rfp.RefundReason || rfp.Autorefund || rfp.DisableReason;
		}

		return rfp;
	}

	RefreshCurrent() {
		this.Get({
			RefreshCurrent: true,
		});
	}

	async Get(options = {
		RefreshCurrent: false,
		LoadFrom: undefined,
		Filters: undefined,
		Query: undefined,
	}) {
		const result = {
			Rfps: [],
		};

		if (!options.LoadFrom) { this.ExpiredItemsCount = 0; }
		this.LoadingMore = true;

		let limit = 25;
		if (options.RefreshCurrent && this.Rfps.length) {
			limit = this.Rfps.length;
		}
		let url = this.GetListUrl(limit);

		if (options.LoadFrom) {
			url += `&data.idRfpFrom=${options.LoadFrom.Id}`;
			for (const param in options.LoadFrom.LoadFromData) {
				url += `&data.${param}=${options.LoadFrom.LoadFromData[param] || ''}`;
			}
		}

		let l;
		this.IsLoading = true;
		if (this.Filters.length) {
			const pfu = this.PrepareFiltersUrl(this.Filters);
			this.FiltersCount = pfu.Count;
			l = await serverFetch(url, pfu.DataObject, 'POST');
			this.DefaultSort = l.defaultSort;
		} else {
			l = await serverFetch(url);
			this.DefaultSort = l.defaultSort;
			this.Filters = this.PrepareFilters(options.Filters, l.filter);
			if (options.Query) {
				this.SetFilterQuery(options.Query);
				const get = await this.Get(options);
				return get;
			}
		}

		this.UpdateCategoryFilters(l.filter);
		this.SetFilterQuery(options.Query);

		this.IsLoading = false;
		this.LoadingMore = false;

		if (!l) {
			l = {
				rfps: [],
			};
		}
		this.DisplayIntroMessage = l.preRegistrationOnly || false;
		this.TotalResults = l.total;
		this.newApCategories = l.newApCategories;
		this.newApCategoriesOB = l.newApCategoriesOB;
		this.ArchivedRfpsCount = l.archivedRfpsCount || 0;

		const osl = {};
		if (!l.rfps) { l.rfps = []; }

		const { timePromoRfp } = l;
		if (timePromoRfp) {
			this.timePromoRfp = this.ProcessRfp(timePromoRfp);
			const cp = this.timePromoRfp.ContactPerson;
			osl[cp.OnlineStatusId] = cp.OnlineStatus;
		}

		l.rfps.forEach((r) => {
			r = this.ProcessRfp(r);
			const cp = r.ContactPerson;
			osl[cp.OnlineStatusId] = cp.OnlineStatus;
			result.Rfps.push(r);
			if (r.IsExpired) { this.ExpiredItemsCount++; }
		});

		// jeżeli lista na starcie składa się z samych wygaśniętych, traktuj ją jako pustą.
		if (this.Type === 'Rfps' && this.ExpiredItemsCount === result.Rfps.length && !options.LoadFrom) {
			result.Rfps = [];
			this.TotalResults = 0;
			this.ExpiredItemsCount = 0;
		}

		if (l.tutorials) {
			if (l.tutorials.pfInfoModal) {
				this.PfInfoModal = l.tutorials.pfInfoModal;
			}
			if (l.tutorials.pfLabelTutorial) {
				this.PfLabelTutorial = l.tutorials.pfLabelTutorial;
			}
		}

		this.AdditionalRfps = [];
		if (!l.additionalRfps) { l.additionalRfps = []; }

		l.additionalRfps.forEach((r) => {
			if (r.IsExpired) { return; }
			r = this.ProcessRfp(r);
			const cp = r.ContactPerson;
			osl[cp.OnlineStatusId] = cp.OnlineStatus;
			this.AdditionalRfps.push(r);
		});

		this.AdditionalRfpsSectionLabel = l.additionalRfpsSectionLabel || '';
		this.AdditionalRfpsSectionTooltip = l.additionalRfpsSectionTooltip || '';
		this.OnlineStatusList = osl;

		if (options.LoadFrom) {
			this.Rfps = [...this.Rfps, ...result.Rfps];
		} else {
			this.Rfps = result.Rfps;
		}
		this.Loaded = true;
		return this.Rfps;
	}

	async UpdateOnlineStatus() {
		const b = [];
		const c = [];
		Object.keys(this.OnlineStatusList).forEach((u) => {
			if (u.startsWith('B')) {
				b.push(u.substr(1));
			}
			if (u.startsWith('C')) {
				c.push(u.substr(1));
			}
		});

		const bl = this.GetOnlineStatusList('buyers', b);
		const cl = this.GetOnlineStatusList('custs', c);
		Promise.all([bl, cl]).then((r) => {
			this.OnlineStatusList = {
				...r[0],
				...r[1],
			};
		});
	}

	LoadMore() {
		const lastRfp = (this.Rfps.length) ? this.Rfps[this.Rfps.length - 1] : null;
		return this.Get({
			LoadFrom: lastRfp,
		});
	}

	ById(id) {
		return this.Rfps.find((r) => Number(r.Id) === Number(id));
	}

	ToggleFavourite(rfp) {
		rfp.IsFavourite = !rfp.IsFavourite;
		serverFetch('/myoferteo/konto-json/ulubione-zapytanie.ofer', {
			'data.idRfp': rfp.Id,
			'data.favourite': rfp.IsFavourite,
		}, 'POST');
	}

	RemoveRfpFromList(rfp, index?) {
		const id = rfp.Id;
		if (!index) {
			index = this.Rfps.findIndex((r) => Number(r.Id) === Number(id));
		}
		this.TotalResults--;
		this.Rfps.splice(index, 1);
	}

	RemoveRfp(rfp, index) {
		this.RemoveRfpFromList(rfp, index);
		serverFetch('/myoferteo/konto-json/usun-zapytanie.ofer', {
			'data.idRfps': rfp.Id,
		}, 'POST');
	}

	RemoveRfpsById(rfps) {
		const fd = new FormData();

		for (const id of rfps) {
			const toRemove = this.Rfps.findIndex((r) => Number(r.Id) === Number(id));
			if (toRemove < 0) { continue; }
			fd.append('data.idRfps', id);
			this.TotalResults--;
			this.Rfps.splice(toRemove, 1);
		}

		fetch('/myoferteo/konto-json/usun-zapytanie.ofer', {
			method: 'POST', mode: 'no-cors', credentials: 'include', body: fd,
		});
	}

	ChangeFilter(filter, filters) {
		if (!filters) {
			filters = this.Filters;
		}
		const filterToFound = filters.find((f) => f.Name === filter.Name);
		if (filterToFound) {
			filterToFound.Value = filter.Value;
			this.Get();
		}
	}

	OnSearchFilter() {
		return new Promise((resolve) => {
			this.SearchModified = true;
			window.clearTimeout(this.SearchTimeout);
			this.SearchLoader = true;
			this.SearchTimeout = window.setTimeout(async () => {
				await this.Get();
				this.SearchLoader = false;
				resolve(undefined);
			}, 150);
		});
	}

	UncoverRfp() {
		// Sprawdź czy sukces...

		// Sprawdź zawartość obu list.
		// Jeżeli istnieje na Zapytaniach, usuń.
		// Zaktualizuj listę Kontaktów.
		// Cofnięcie powinno powodować przeniesienie na listę kontaktów. <- da się to załatwić Travelem?
	}

	ProcessPublicInfo(rsvp, rfp, showModal) {
		const result = {
			Meta: {},
			Links: {
				CompanyListBest: null,
				CompanyListLocation: null,
				RfpListLocation: null,
				RfpList: null,
				SeeMoreClients: [],
				SeeAlso: [],
				Breadcrumbs: [],
			},
			CategoryFilter: {},
			UncoveredBy: [],
			SeoRfpList: {
				Name: '',
				Items: [],
			},
			SeoCompanyList: {
				Name: '',
				Items: [],
			},
			SeoOfferList: {
				Name: '',
				Items: [],
			},
			ShowApModal: showModal || false,
		};

		// Metadane:
		rsvp = rsvp || {};
		rsvp.metaTags = rsvp.metaTags || [];
		for (const k in rsvp.metaTags) {
			result.Meta[k] = rsvp.metaTags;
		}

		// Rozmaite SEO-linki
		if (rsvp.links) {
			result.Links.CompanyListBest = {
				Label: rsvp.links.bestCompaniesListLocation.title, // 'Fotowoltaika we Wrocławiu',
				Url: rsvp.links.bestCompaniesListLocation.url, // 'https://www.oferteo.pl/fotowoltaika/wroclaw#najlepsi'
			};
			result.Links.CompanyListLocation = {
				Label: rsvp.links.companiesListLocation.title, // 'Fotowoltaika Wrocław',
				Url: rsvp.links.companiesListLocation.url, // 'https://www.oferteo.pl/fotowoltaika/wroclaw'
			};
			result.Links.RfpListLocation = {
				Label: rsvp.links.rfpListLocation.title, // 'Kupię panele fotowoltaiczne Wrocław',
				Url: rsvp.links.rfpListLocation.url, // 'https://www.oferteo.pl/kupie-panele-fotowoltaiczne/wroclaw'
			};
			result.Links.RfpList = {
				Label: rsvp.links.rfpList.title, // 'Kupię panele fotowoltaiczne',
				Url: rsvp.links.rfpList.url, // 'https://www.oferteo.pl/kupie-panele-fotowoltaiczne'
			};
		}

		// Zobacz więcej Klientów
		rsvp.moreClients = rsvp.moreClients || [];
		for (const i of rsvp.moreClients) {
			result.Links.SeeMoreClients.push({
				Label: i.title,
				Url: i.url,
			});
		}

		// Podobne tematy
		rsvp.relatedTopics = rsvp.relatedTopics || [];
		for (const subsection of rsvp.relatedTopics) {
			const arr = [];
			for (const i of subsection) {
				arr.push({
					Label: i.title,
					Url: i.url,
				});
			}
			result.Links.SeeAlso.push(arr);
		}

		// Okruszki
		rsvp.breadCrumbs = rsvp.breadCrumbs || [];
		for (const i of rsvp.breadCrumbs) {
			result.Links.Breadcrumbs.push({
				Label: i.anchor,
				Url: i.url,
			});
		}

		result.CategoryFilter = {
			Id: -1,
			Type: '', // czy użytkownik ma filtr? (''|'notification'|'automatic')
			CanBeAutomatic: false, // czy kategoria może mieć włączone AP
		};

		const filter = rsvp.customerFilter;
		if (filter) {
			let type = filter.idType;
			if (type === 'mgFltrTypeNotif') {
				type = 'notification';
			}
			if (type === 'mgFltrTypeIm') {
				type = 'automatic';
			}
			result.CategoryFilter = {
				Id: filter.idFilter, // na razie nie będzie używane
				Type: type,
				CanBeAutomatic: filter.enabledForIm,
			};
		}

		// Lista firm, przez które zostało odkryte zapytanie (może zastąpić istniejącą listę..?)
		rsvp.customersWhoUncovered = rsvp.customersWhoUncovered || [];
		for (const i of rsvp.customersWhoUncovered) {
			const gallery = (g) => {
				const galleryResult = [];
				for (const galleryPhoto of g.fotoList) {
					galleryResult.push({
						Thumbnail: galleryPhoto.thumbnailUrl,
						Url: galleryPhoto.origUrl,
						Description: galleryPhoto.description || galleryPhoto.alt,
					});
				}
				return galleryResult;
			};

			const review = (r) => {
				if (!r) {
					return {};
				}
				const reviewResult = {
					Author: `${r.firstName} ${r.lastName || ''}`,
					AuthorAvatar: '#TODO',
					Rating: this.Format.RatingToNumber(r.idMarkValue),
					Content: r.description,
				};
				return reviewResult;
			};

			result.UncoveredBy.push({
				Id: i.idCustomer,
				Avatar: i.avatarPath,
				Url: i.customerUrl,
				Name: i.companyName,
				UncoveredDate: new Date(i.tsUncovered),
				Rating: Math.round(i.rating) * 2,
				RatingAverage: i.rating,
				ReviewCount: i.reviewsCount,

				Description: i.description,
				YearsOnMarket: i.yearsOnMarket,
				YearsInOferteo: i.yearsInOferteo,
				OffersCount: i.offersCount,
				Gallery: gallery(i.portfolio),
				Review: review(i.mark),
			});
		}

		const categoryName = rfp.Category[1];

		// Listy, które pojawiają się tylko na desktopie
		rsvp.rfpsSeoBookmarks = rsvp.rfpsSeoBookmarks || [];
		for (const i of rsvp.rfpsSeoBookmarks) {
			const description = (list) => {
				// TODO: Zabić Maćka U.
				const descriptionResult = [];
				list.forEach((item) => {
					item = Object.entries(item)[0];
					descriptionResult.push(`${item[0]}: ${item[1]}`);
				});
				return descriptionResult;
			};

			const isHashed = !!i.hrefHashed;

			result.SeoRfpList.Name = `Inne zlecenia z kategorii ${categoryName}`;
			result.SeoRfpList.Items.push({
				Name: i.title,
				Url: isHashed ? '#' : i.rfpUrl,
				Hash: i.hrefHashed,
				Date: new Date(i.tsActivated),
				Description: description(i.descriptionList),
				Location: (i.location && i.location.city) ? i.location.city[1] : '',
				OfferCount: i.uncoversCount,
			});
		}

		rsvp.customersSeoBookmarks = rsvp.customersSeoBookmarks || [];
		for (const i of rsvp.customersSeoBookmarks) {
			result.SeoCompanyList.Name = `Firmy z branży ${categoryName}`;
			result.SeoCompanyList.Items.push({
				Name: i.companyName,
				Url: i.url,
				Rating: i.rating,
				Description: i.description,
			});
		}

		rsvp.offersSeoBookmarks = rsvp.offersSeoBookmarks || [];
		for (const i of rsvp.offersSeoBookmarks) {
			result.SeoOfferList.Name = `Oferty z branży ${categoryName}`;
			result.SeoOfferList.Items.push({
				Name: i.title,
				Url: i.offerUrl,
				Description: i.description,
			});
		}

		rfp.PublicInfo = result;
		return rfp;
	}

	async GetRfp(rfpId, isPublic) {
		const url = isPublic ? '/public/json/find-rfp-data.ofer?idRfp=' : '/myoferteo/konto-json/zapytanie.ofer?data.idRfp=';
		const rsvp = await serverFetch(url + rfpId);

		let toProcess = rsvp;

		if (isPublic) {
			toProcess = rsvp.rfpPublicDTO ? rsvp.rfpPublicDTO.rfpData : {};
		}

		let r = this.ProcessRfp(toProcess);

		if (isPublic) {
			r = this.ProcessPublicInfo(rsvp.rfpPublicDTO, r, rsvp.showApModal);
		}

		r.RedirectToList = rsvp.redirectToList;
		return r;
	}
}
